import type * as TF from 'type-fest';
import type { DelegateTaskToolInvocation, ToolInvocation } from './types';

/**
 * Check if the tool invocation is a sub-agent tool invocation.
 *
 * @param toolInvocation - The tool invocation to check.
 * @returns True if the tool invocation is a sub-agent tool invocation, false otherwise.
 */
export function isSubAgentToolInvocation(
  toolInvocation: ToolInvocation
): toolInvocation is TF.SetRequired<
  ToolInvocation,
  'subAgentId' | 'subAgentName'
> {
  return (
    'subAgentId' in toolInvocation &&
    'subAgentName' in toolInvocation &&
    isValidString(toolInvocation.subAgentId) &&
    isValidString(toolInvocation.subAgentName)
  );
}

/**
 * Check if the tool invocation is a supervisor agent (delegate_task) tool invocation.
 *
 * @param toolInvocation - The tool invocation to check.
 * @returns True if the tool invocation is a supervisor agent (delegate_task) tool invocation, false otherwise.
 */
export function isDelegateTaskToolInvocation(
  toolInvocation: ToolInvocation
): toolInvocation is DelegateTaskToolInvocation {
  return toolInvocation.toolName === 'delegate_task';
}

function isValidString(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0;
}
